import { Redirect } from 'react-router-dom';
import React , { useContext } from 'react';
import { AuthContext } from '../../context/auth';

const LogOut = function(){
    const { logout } = useContext(AuthContext);
    logout();
    return(
        <Redirect to={"/"} />
    )
}

export default LogOut;